import { DateTime } from 'luxon'

const getJSDate = (date: Date | string) => {
  if (typeof date === 'string') {
    date = new Date(date)
  }
  return DateTime.fromJSDate(date)
}

export const formatLaunchingDate = (date: Date | string | undefined) => {
  if (!date) {
    return '-'
  }

  const jsDate = getJSDate(date)

  if (jsDate.year === 9999) {
    return '-' // 미정
  }

  if (jsDate.minute) {
    if (jsDate.hour) {
      return jsDate.setLocale('en-US').toFormat('yyyy') // 월, 일 선택안함
    }

    return jsDate.setLocale('en-US').toFormat('MMM, yyyy') // 일 선택안함
  }

  return jsDate.setLocale('en-US').toLocaleString(DateTime.DATE_MED) // 기본
}

export const formatAbbrDate = (date: Date | string | undefined) => {
  if (!date) {
    return '-'
  }
  const jsDate = getJSDate(date)
  if (!jsDate.isValid) {
    return '-'
  }
  return jsDate.setLocale('en-US').toLocaleString(DateTime.DATE_MED) // 기본
}

export const formatDotDate = (date: Date | string | undefined, showTime = false) => {
  if (!date) {
    return '-'
  }
  const jsDate = getJSDate(date)
  if (showTime) {
    return jsDate.setLocale('en-US').toFormat('yyyy.MM.dd HH:mm')
  }
  return jsDate.setLocale('en-US').toFormat('yyyy.MM.dd')
}

export const formatShortSlashDate = (date: Date | string | undefined) => {
  if (!date) {
    return '-'
  }
  const jsDate = getJSDate(date)
  return jsDate.setLocale('en-US').toFormat('MM/dd')
}

export const getDaysDiff = (standardDate: Date | string, compareDate: Date | string) => {
  const standardDateTime = getJSDate(standardDate)
  const compareDateTime = getJSDate(compareDate)
  return Math.floor(standardDateTime.diff(compareDateTime, [ 'days' ]).toObject().days || 0)
}

export const convertDateToAge = (date: Date | string) => {
  const MILLISECONDS = {
    minute: 1000 * 60,
    hour: 1000 * 60 * 60,
    day: 1000 * 60 * 60 * 24,
    week: 1000 * 60 * 60 * 24 * 7,
  }

  if (typeof date === 'string') {
    date = new Date(date)
  }
  const now = new Date()
  const diff = now.getTime() - date.getTime()

  if (diff >= 0 && diff < MILLISECONDS.minute) {
    return 'Just Now'
  }
  if (diff >= MILLISECONDS.minute && diff < MILLISECONDS.hour) {
    const min = Math.floor(diff / MILLISECONDS.minute)
    if (min === 1) {
      return `${min} min ago`
    }
    return `${min} mins ago`
  }
  if (diff >= MILLISECONDS.hour && diff < MILLISECONDS.day) {
    const hour = Math.floor(diff / MILLISECONDS.hour)
    if (hour === 1) {
      return `${hour} hour ago`
    }
    return `${hour} hours ago`
  }
  if (diff >= MILLISECONDS.day && diff < MILLISECONDS.week) {
    let day = now.getDate() - date.getDate()
    if (day < 0) {
      day += new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
    }

    if (day === 1) {
      return `${day} day ago`
    }
    return `${day} days ago`
  }
  return formatAbbrDate(date)
}